var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 33,
    viewBox: "0 0 54 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1471 0.696238H14.9341V28.1959H17.1471V0.696238Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4861 0.618395H15.4387V1.35528H20.4861V0.618395Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0205 1.35593H19.6711V6.59199H20.0205V1.35593Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9815 5.70006H15.7108V6.43695H19.9815V5.70006Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1548 18.8429L20.2217 21.155L25.3368 27.3091H28.8463L26.7559 20.2599L22.3497 18.7682L21.1548 18.8429Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0342 7.2804H41.5034V13.099H43.0342V7.2804Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9421 7.17577C41.9421 7.17577 42.0494 6.0197 42.842 5.74153C43.6352 5.46337 45.5851 5.12077 45.5851 5.12077L44.7919 5.9559L43.1843 6.29852C43.1843 6.29852 42.7769 6.42676 42.6702 6.68387C42.5629 6.94099 42.5201 7.26189 42.5201 7.26189L41.9421 7.17577Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8994 13.1921V13.8773H42.4346V13.1493L41.8994 13.1921Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1297 13.9194H50.7998C50.7998 13.9194 52.1065 13.9941 52.4054 15.1501C52.7043 16.3062 53.115 21.2666 53.115 21.2666L53.2644 27.3461H40.8315V20.2599H41.8023L41.1297 13.9194Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8315 27.3461H53.2644L53.1284 21.8H40.8315V27.3461Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1364 22.6096C50.0538 20.9687 48.7471 20.7817 48.7471 20.7817H44.9943C42.7692 21.1467 41.5052 23.4639 40.8321 25.3651V27.3461H52.0375C52.058 26.7796 52.1027 24.0738 51.1364 22.6096Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8649 20.3498L22.0566 18.7504H17.9883L18.0317 19.1395H22.1L26.038 20.7824L28.2453 27.8725H41.2287C41.2287 27.8725 41.2721 22.5548 44.9937 20.7824V19.6148H26.1249L25.8649 20.3498Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3282 15.8598L19.0322 16.6606L22.0189 17.7623L22.3149 16.9615L19.3282 15.8598Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2113 16.0484L19.0632 16.4491L16.6113 15.4474L16.7588 15.0474L19.2113 16.0484Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.181 19.4847L40.2765 2.32186H40.7523L40.6226 1.58688H25.0858L25.3885 2.23573H26.86C26.86 2.23573 25.172 3.35987 24.6962 4.78644C24.2204 6.21301 20.8444 18.7937 20.8444 18.7937H22.056L25.9512 4.65695C25.9512 4.65695 26.9897 3.14361 28.1584 2.79781C29.3265 2.45202 38.9347 2.6683 38.9347 2.6683L40.9254 19.5721L42.181 19.4847Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4418 13.6055C23.4418 13.6055 25.6057 10.8385 26.0815 10.6222C26.5573 10.4059 26.6876 10.406 27.2068 10.5361C27.726 10.6656 27.7695 11.0548 27.4667 11.5735C27.164 12.0922 25.3464 15.2484 25.3464 16.1129C25.3464 16.9774 25.6063 17.1936 25.9525 17.8852C26.2986 18.5768 25.8662 20.3492 25.8662 20.3492L22.0579 18.7931L23.4418 13.6055Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2756 8.97875L29.3278 10.7734",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9903 9.54084L27.0331 10.406L27.4661 10.6222L27.7694 10.0168",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9903 9.54084L27.0331 10.406L27.4661 10.6222L27.7694 10.0168",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4661 10.6222L27.7477 10.8602L28.6348 10.4493",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4661 10.6222L27.7477 10.8602L28.6348 10.4493",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1113 10.4276L29.3278 10.0819",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1755 13.8237C40.1755 13.8237 31.8384 14.7609 31.4909 15.1769C31.1435 15.5929 30.379 17.1203 30.379 18.0919C30.379 19.0636 30.379 19.0636 30.379 19.0636H26.1753L26.1242 19.6142L40.9253 19.5708L40.1755 13.8237Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9178 12.3295L38.5916 8.87028C38.5916 8.87028 38.0801 8.96344 37.2901 9.14909C36.5 9.33475 35.8958 9.86876 35.6168 10.8436C35.3377 11.8185 36.2445 12.8865 36.2445 12.8865C36.2445 12.8865 36.1513 13.3044 36.0587 13.3739C35.9654 13.4435 31.0618 14.024 31.0618 14.024L31.0848 15.0691L37.778 14.0011C37.778 14.0011 38.1733 12.6779 38.1963 12.5382C38.22 12.3991 37.9178 12.3295 37.9178 12.3295ZM37.1974 12.0507C37.1974 12.0507 36.454 11.888 36.3142 11.2379C36.1749 10.5878 37.2204 9.68246 37.8016 9.63589L37.1974 12.0507Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0616 26.3017C51.0616 23.9124 49.1226 21.9754 46.7308 21.9754C44.339 21.9754 42.4 23.9124 42.4 26.3017C42.4 28.691 44.339 30.628 46.7308 30.628C49.1226 30.6286 51.0616 28.6917 51.0616 26.3017Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7309 28.5232C47.959 28.5232 48.9547 27.5286 48.9547 26.3017C48.9547 25.0748 47.959 24.0802 46.7309 24.0802C45.5027 24.0802 44.507 25.0748 44.507 26.3017C44.507 27.5286 45.5027 28.5232 46.7309 28.5232Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3292 29.1057C26.3632 27.0739 26.3632 23.7796 24.3292 21.7478C22.2953 19.716 18.9976 19.716 16.9636 21.7478C14.9297 23.7797 14.9297 27.0739 16.9636 29.1057C18.9976 31.1376 22.2953 31.1376 24.3292 29.1057Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3256 25.4257C23.3256 23.95 22.1281 22.7544 20.6515 22.7544C19.1742 22.7544 17.9767 23.9507 17.9767 25.4257C17.9767 26.9014 19.1742 28.0971 20.6515 28.0971C22.1281 28.0971 23.3256 26.9008 23.3256 25.4257Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6225 1.16134V2.92604C18.6225 3.37966 18.4161 3.80904 18.061 4.09231C17.796 4.30413 17.4664 4.4196 17.1267 4.4196H15.438V0.89018L18.6225 1.16134Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6524 11.867H12.6043V26.4899H13.6524V11.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.74 19.5855H13.7303V26.1014H14.74V19.5855Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.723206 25.9853H12.6043V26.4893H4.02382L0.723206 25.9853Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.7c6405cd421fa60a26b0afe1e5ead549.svg";
export { ForwardRef as ReactComponent };